<template>
  <div class="container-fluid streams-content-page">
    <section class="streams-content-hero">
      <div class="hero-top-row">
        <div class="hero-stream-meta">
          <span class="stream-type-pill">
            {{ streamData.type }}
            <span v-if="streamData.type === 'TELEGRAM'" class="stream-type-chat">
              {{ streamData.settings.chatId }}
            </span>
          </span>
          <span v-if="streamData.name" class="stream-name-pill">
            {{ streamData.name }}
          </span>
        </div>

      <!-- Кнопка Создать контент -->
      <div class="hero-actions">
      <router-link
          to="/streams"
          class="btn btn-sm btn-outline-secondary hero-btn hero-btn--ghost"
      >
        <i class="bi bi-arrow-left me-1"></i> Назад
      </router-link>
      <button class="btn btn-sm btn-primary hero-btn hero-btn--primary" @click="createContent">
        <i class="bi bi-plus-lg me-1"></i> Создать
      </button>
      <!-- Кнопка «Настройки стрима» -->
      <router-link
          :to="`/streams/${streamId}/edit`"
          class="btn btn-sm btn-outline-secondary hero-btn hero-btn--ghost"
      >
        <i class="bi bi-gear me-1"></i> Настройки
      </router-link>
      <button
          v-if="isWordpressStream"
          class="btn btn-sm hero-btn hero-btn--sync sync-taxonomies-btn"
          :disabled="!canSyncWordpressTaxonomies || syncTaxonomiesLoading"
          :title="!canSyncWordpressTaxonomies ? 'Задайте URL и Credentials в настройках стрима' : ''"
          @click="syncWordpressTaxonomies"
      >
        <span v-if="syncTaxonomiesLoading" class="spinner-border spinner-border-sm me-1"></span>
        <i v-else class="bi bi-arrow-repeat me-1"></i>
        Синк категорий
      </button>

      <!-- Пагинация -->
      </div>
      </div>
      <div class="hero-bottom-row">
        <div v-if="false" class="dropdown position-static status-filter-dropdown" data-bs-boundary="viewport">
          <button
            class="btn btn-sm btn-outline-secondary dropdown-toggle status-filter-btn"
            type="button"
            data-bs-toggle="dropdown"
            data-bs-boundary="viewport"
          >
            <i class="bi bi-funnel me-1"></i>
            Статусы
          </button>
          <ul class="dropdown-menu p-2 status-filter-menu">
            <li v-for="status in availableStatuses" :key="status" class="form-check status-check-item">
              <input
                class="form-check-input"
                type="checkbox"
                :id="`status-filter-${status}`"
                :value="status"
                v-model="selectedStatuses"
              />
              <label class="form-check-label" :for="`status-filter-${status}`">
                {{ status }}
              </label>
            </li>
          </ul>
        </div>
        <div class="hero-pagination-wrap">
          <small v-if="totalPages > 0" class="text-muted page-size-indicator">
            По {{ pageSize }} на странице
          </small>
          <nav v-if="totalPages > 0" class="hero-pagination">
        <ul class="pagination pagination-sm mb-0">
          <li
              class="page-item"
              :class="{ disabled: currentPage === 1 }"
              @click="currentPage = Math.max(1, currentPage - 1)"
          >
            <a class="page-link">«</a>
          </li>
          <li
              class="page-item"
              v-for="page in totalPages"
              :key="page"
              :class="{ active: page === currentPage }"
              @click="currentPage = page"
          >
            <a class="page-link">{{ page }}</a>
          </li>
          <li
              class="page-item"
              :class="{ disabled: currentPage === totalPages }"
              @click="currentPage = Math.min(totalPages, currentPage + 1)"
          >
            <a class="page-link">»</a>
          </li>
        </ul>
          </nav>
        </div>
      </div>
    </section>

    <!-- Секция с таблицей контента -->
    <section
      v-if="isWordpressStream && (showWpSyncWarning || syncTaxonomiesMessage || syncTaxonomiesError)"
      class="px-3 pb-2"
    >
      <div
        v-if="syncTaxonomiesMessage || syncTaxonomiesError"
        class="alert py-2 px-3 mb-0"
        :class="syncTaxonomiesError ? 'alert-danger' : 'alert-success'"
      >
        {{ syncTaxonomiesError || syncTaxonomiesMessage }}
      </div>
      <div v-else class="streams-content-warning mb-0">
        Для синхронизации категорий и меток требуется задать URL и Credentials в настройках!
      </div>
    </section>
    <section class="streams-content-table-card">
    <div v-if="loading" class="streams-content-loading">Загрузка...</div>
    <template v-else>
      <ContentTable
          :contents="contents"
          :sortBy="sortBy"
          :sortDir="sortDir"
          :publishAllowed="publishAllowed"
          :stream-type="streamData.type"
          :chat-id="streamData.settings?.chatId || ''"
          :site-url="streamData.settings?.siteUrl || ''"
          :host="streamData.settings?.host || ''"
          @change-sort="handleChangeSort"
          @edit-content="openEditModal"
          @generate-content="openGeneratePage"
          @delete-content="openDeleteContentModal"
          @archive-content="archiveContent"
          @copy-content="copyContent"
      >
        <template #status-header>
          <div class="dropdown position-static status-filter-dropdown" data-bs-boundary="viewport">
            <button
              class="btn btn-sm btn-outline-secondary dropdown-toggle status-filter-btn status-filter-btn--inline"
              type="button"
              data-bs-toggle="dropdown"
              data-bs-boundary="viewport"
            >
              Статус
            </button>
            <ul class="dropdown-menu p-2 status-filter-menu">
              <li v-for="status in availableStatuses" :key="status" class="form-check status-check-item">
                <input
                  class="form-check-input"
                  type="checkbox"
                  :id="`status-inline-filter-${status}`"
                  :value="status"
                  v-model="selectedStatuses"
                />
                <label class="form-check-label" :for="`status-inline-filter-${status}`">
                  {{ status }}
                </label>
              </li>
            </ul>
          </div>
        </template>
      </ContentTable>
      <div v-if="contents.length === 0" class="alert alert-info streams-content-empty mb-0">
        Нет контента для этого стрима.
      </div>
    </template>
    </section>

    <div v-if="showDeleteContentModal" class="delete-content-backdrop" @click.self="closeDeleteContentModal">
      <div class="modal-container delete-content-modal">
        <div class="delete-content-head">
          <div class="delete-content-icon"><i class="bi bi-exclamation-triangle"></i></div>
          <div class="delete-content-title-wrap">
            <h6 class="delete-content-title mb-0">Подтвердите удаление контента</h6>
            <div class="delete-content-subtitle">Эта операция необратима</div>
          </div>
          <button type="button" class="delete-content-close" :disabled="deleteContentLoading" @click="closeDeleteContentModal">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>

        <div class="delete-content-body">
          <div class="delete-content-item">
            <span class="text-muted">Название:</span>
            <strong>{{ deleteTargetContent?.title || `#${deleteTargetContent?.id || ''}` }}</strong>
          </div>
          <div v-if="deleteContentError" class="alert alert-danger py-1 px-2 small mt-2 mb-0">{{ deleteContentError }}</div>
        </div>

        <div class="delete-content-footer">
          <button class="btn btn-secondary btn-sm me-2" :disabled="deleteContentLoading" @click="closeDeleteContentModal">Отмена</button>
          <button class="btn btn-danger btn-sm" :disabled="deleteContentLoading" @click="confirmDeleteContent">
            <span v-if="deleteContentLoading" class="spinner-border spinner-border-sm me-1"></span>
            Удалить
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { computed, onBeforeUnmount, ref, onMounted, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import ContentTable from './content/ContentTable.vue'
export default {
  name: 'StreamsContent',
  components: {
    ContentTable,
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const streamId = route.params.id

    const HEADER_HEIGHT = 117; // высота «шапки» (px)
    const ROW_HEIGHT = 51;

    function calculatePageSize() {
      if (typeof window === 'undefined') return 10
      const available = Math.max(0, Number(window.innerHeight || 0) - HEADER_HEIGHT)
      return Math.max(1, Math.floor(available / ROW_HEIGHT))
    }

    // ================================
    // Состояние доступности публикации
    // ================================
    const publishAllowed = ref({ ok: false, message: '' })

    const fetchPublishAllowed = async () => {
      try {
        const response = await axios.get(`/api/publish/${streamId}/isOk`)
        const data = response.data
        if (typeof data === 'object' && 'ok' in data) {
          publishAllowed.value = {
            ok: data.ok,
            message: data.message || ''
          }
        } else if (typeof data === 'boolean') {
          // на случай, если сервер всё ещё иногда возвращает просто Boolean
          publishAllowed.value = {ok: data, message: ''}
        } else {
          publishAllowed.value = {ok: false, message: 'Некорректный ответ от сервера'}
        }
      } catch (err) {
        console.error('Ошибка при получении доступности публикации:', err)
        publishAllowed.value = {
          ok: false,
          message: 'Не удалось проверить доступность публикации'
        }
      }
    }

    // ===========================================
    // 1. Состояние для модалки «Настройки стрима»
    // ===========================================
    const streamData = ref({
      id: '',
      name: '',
      description: '',
      type: '',
      settings: {}
    })
    const syncTaxonomiesLoading = ref(false)
    const syncTaxonomiesMessage = ref('')
    const syncTaxonomiesError = ref('')
    const SYNC_TAXONOMIES_TOAST_MS = 5000
    let syncTaxonomiesToastTimer = null
    const isWordpressStream = computed(() => String(streamData.value?.type || '').toUpperCase() === 'WORDPRESS')
    const hasWordpressSiteUrl = computed(() =>
      Boolean(
        String(
          streamData.value?.settings?.siteUrl
          || streamData.value?.settings?.host
          || streamData.value?.siteUrl
          || streamData.value?.host
          || ''
        ).trim()
      )
    )
    const hasWordpressCredential = computed(() => {
      const fromSettings = streamData.value?.settings?.wordpressCredential
      const fromRoot = streamData.value?.credential
      const credential = fromSettings || fromRoot
      const credentialId = streamData.value?.credentialId

      if (credentialId !== null && credentialId !== undefined && String(credentialId).trim() !== '') return true
      if (!credential) return false

      if (typeof credential === 'object') {
        return Boolean(
          credential.id
          || credential.credentialId
          || String(credential.label || '').trim()
          || String(credential.login || '').trim()
          || String(credential.username || '').trim()
        )
      }

      return Boolean(String(credential).trim())
    })
    const showWpSyncWarning = computed(() =>
      isWordpressStream.value && (!hasWordpressSiteUrl.value || !hasWordpressCredential.value)
    )
    const canSyncWordpressTaxonomies = computed(() =>
      isWordpressStream.value && hasWordpressSiteUrl.value && hasWordpressCredential.value
    )

    // ===========================================
    // 2. Состояние для контента стрима
    // ===========================================
    const contents = ref([])
    const loading = ref(true)
    const sortBy = ref('updatedAt')
    const sortDir = ref('desc')

    // Модалки контента
    const showDeleteContentModal = ref(false)
    const deleteTargetContent = ref(null)
    const deleteContentLoading = ref(false)
    const deleteContentError = ref('')

    const currentPage = ref(1)
    const pageSize = ref(calculatePageSize())
    const totalPages = ref(1)
    const availableStatuses = ['CREATED', 'DRAFT', 'READY', 'PUBLISHED', 'ERROR', 'ARCHIVE']
    const selectedStatuses = ref(['CREATED', 'DRAFT', 'READY', 'PUBLISHED', 'ERROR'])

    // -------------------------------------------
    // Функция: получить список контента из API
    // -------------------------------------------
    const fetchContents = async () => {
      loading.value = true;
      try {
        const params = {
          sortBy: sortBy.value,
          sortDir: sortDir.value,
          page: currentPage.value - 1,
          size: pageSize.value,
          statuses: selectedStatuses.value.join(',')
        };
        const response = await axios.get(
            `/api/contents/stream/${streamId}`,
            { params }
        );
        // Считаем, что сервер возвращает { content: [...], totalPages: N }
        const responseData = response.data || {}
        const pageMeta = (responseData.page && typeof responseData.page === 'object')
          ? responseData.page
          : responseData
        const rawTotalPages = Number(pageMeta.totalPages)
        const rawTotalElements = Number(pageMeta.totalElements)
        const rawPageNumber = Number(pageMeta.number)
        const hasNextByLastFlag = pageMeta.last === false

        const resolvedByElements = Number.isFinite(rawTotalElements) && rawTotalElements >= 0
          ? Math.ceil(rawTotalElements / Math.max(1, Number(pageSize.value || 1)))
          : 0

        let resolvedTotalPages = Number.isFinite(rawTotalPages) && rawTotalPages > 0
          ? rawTotalPages
          : (resolvedByElements > 0 ? resolvedByElements : 1)

        // Fallback for APIs that don't return totalPages correctly but expose "last"/"number"
        if (hasNextByLastFlag && resolvedTotalPages <= currentPage.value) {
          if (Number.isFinite(rawPageNumber) && rawPageNumber >= 0) {
            resolvedTotalPages = Math.max(resolvedTotalPages, rawPageNumber + 2)
          } else {
            resolvedTotalPages = Math.max(resolvedTotalPages, currentPage.value + 1)
          }
        }
        if (currentPage.value > resolvedTotalPages) {
          currentPage.value = resolvedTotalPages
          return
        }

        contents.value = Array.isArray(responseData.content) ? responseData.content : []
        totalPages.value = resolvedTotalPages
      } catch (error) {
        console.error('Ошибка при получении контента:', error);
      } finally {
        loading.value = false;
      }
    };

    watch(
        () => [currentPage.value, selectedStatuses.value, sortBy.value, sortDir.value],
        () => {
          fetchContents()
        }
    )

    const formatDate = (dateString) => {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleDateString()
    }

    const handleChangeSort = (field) => {
      if (sortBy.value === field) {
        sortDir.value = sortDir.value === 'asc' ? 'desc' : 'asc'
      } else {
        sortBy.value = field
        sortDir.value = 'asc'
      }
      fetchContents()
    }

    const openDeleteContentModal = (content) => {
      deleteTargetContent.value = content
      deleteContentError.value = ''
      showDeleteContentModal.value = true
    }

    const closeDeleteContentModal = () => {
      showDeleteContentModal.value = false
      deleteTargetContent.value = null
      deleteContentError.value = ''
    }

    const confirmDeleteContent = async () => {
      if (!deleteTargetContent.value) return
      deleteContentLoading.value = true
      deleteContentError.value = ''
      try {
        await axios.delete(`/api/contents/${deleteTargetContent.value.id}`)
        await fetchContents()
        closeDeleteContentModal()
      } catch (error) {
        console.error('Ошибка при удалении контента:', error)
        deleteContentError.value = 'Не удалось удалить контент.'
      } finally {
        deleteContentLoading.value = false
      }
    }

    // *******************************************
    //  Раздел редактирования / сохранения контента
    // *******************************************
    const openEditModal = (content) => {
      const targetStreamId = normalizeRouteId(content?.streamId) || normalizeRouteId(streamId)
      const targetContentId = normalizeRouteId(content?.id)
      if (!targetStreamId || !targetContentId) return

      router.push(`/streams/${encodeURIComponent(targetStreamId)}/content/${encodeURIComponent(targetContentId)}/edit`)
    }

    // Создание нового контента
    const createContent = async () => {
      const randomLetters = Array.from({ length: 6 }, () =>
          String.fromCharCode(97 + Math.floor(Math.random() * 26))
      ).join('')
      const newContent = {
        title: `Публикация № ${randomLetters}`,
        body: '',
        streamId: streamId,
      }
      try {
        await axios.post('/api/contents', newContent)
        fetchContents()
      } catch (error) {
        console.error('Ошибка при создании контента:', error)
        alert('Не удалось создать контент.')
      }
    }

    const normalizeRouteId = (value) => {
      const text = String(value ?? '').trim()
      return text && text !== 'undefined' && text !== 'null' ? text : ''
    }

    // Генерация контента
    const openGeneratePage = (content) => {
      const targetStreamId = normalizeRouteId(content?.streamId) || normalizeRouteId(streamId)
      const targetContentId = normalizeRouteId(content?.id)
      if (!targetStreamId || !targetContentId) return

      router.push(`/streams/${encodeURIComponent(targetStreamId)}/content/${encodeURIComponent(targetContentId)}/generate`)
    }

    const fetchStreamData = async () => {
      try {
        const response = await axios.get(`/api/streams/${streamId}`)
        streamData.value = {
          ...response.data,
          settings: { ...response.data.settings }
        }
      } catch (err) {
        console.error('Не удалось загрузить данные стрима:', err)
      }
    }

    // ------------------------------------------------------------------------------
    // Когда компонент монтируется, сразу подгружаем контент для текущего стрима
    // ------------------------------------------------------------------------------
    const clearSyncTaxonomiesToast = () => {
      if (syncTaxonomiesToastTimer) {
        clearTimeout(syncTaxonomiesToastTimer)
        syncTaxonomiesToastTimer = null
      }
      syncTaxonomiesMessage.value = ''
      syncTaxonomiesError.value = ''
    }

    const showSyncTaxonomiesToast = ({ message = '', error = '' } = {}) => {
      if (syncTaxonomiesToastTimer) clearTimeout(syncTaxonomiesToastTimer)
      syncTaxonomiesMessage.value = String(message || '')
      syncTaxonomiesError.value = String(error || '')
      syncTaxonomiesToastTimer = setTimeout(() => {
        syncTaxonomiesMessage.value = ''
        syncTaxonomiesError.value = ''
        syncTaxonomiesToastTimer = null
      }, SYNC_TAXONOMIES_TOAST_MS)
    }

    const syncWordpressTaxonomies = async () => {
      if (!canSyncWordpressTaxonomies.value || syncTaxonomiesLoading.value) return
      syncTaxonomiesLoading.value = true
      clearSyncTaxonomiesToast()
      try {
        const numericStreamId = Number(streamId)
        const { data } = await axios.post(
          '/api/publish/wordpress/sync-taxonomies',
          null,
          { params: { streamId: Number.isFinite(numericStreamId) ? numericStreamId : streamId } }
        )

        if (data?.success) {
          showSyncTaxonomiesToast({ message: 'Синхронизация категорий и меток выполнена.' })
          return
        }

        showSyncTaxonomiesToast({
          error: String(data?.errorMessage || 'Не удалось выполнить синхронизацию категорий и меток.')
        })
      } catch (error) {
        showSyncTaxonomiesToast({
          error: String(
            error?.response?.data?.errorMessage
            || error?.response?.data?.message
            || 'Не удалось выполнить синхронизацию категорий и меток.'
          )
        })
      } finally {
        syncTaxonomiesLoading.value = false
      }
    }

    onMounted(async () => {
      await fetchStreamData()
      await fetchPublishAllowed()
      await fetchContents()
    })

    onBeforeUnmount(() => {
      if (syncTaxonomiesToastTimer) clearTimeout(syncTaxonomiesToastTimer)
    })

    // *******************************************
    //  Функция архивации контента
    // *******************************************
    const archiveContent = async (content) => {
      try {
        const response = await axios.get(
            `/api/contents/archive/${content.id}`
        )
        // Если сервер вернул true — обновляем таблицу
        if (response.data === true) {
          fetchContents()
        }
      } catch (error) {
        console.error('Ошибка при архивировании контента:', error)
      }
    }

    // *******************************************
    //  Функция копирования контента
    // *******************************************
    const copyContent = async (content) => {
      try {
        const response = await axios.get(
            `/api/contents/copy/${content.id}`
        )
        // Если сервер вернул true — обновляем таблицу
        if (response.data === true) {
          fetchContents()
        }
      } catch (error) {
        console.error('Ошибка при копировании контента:', error)
      }
    }

    return {
      streamId,
      loading, contents, sortBy, sortDir, handleChangeSort, formatDate, openDeleteContentModal, closeDeleteContentModal,
      confirmDeleteContent, showDeleteContentModal, deleteTargetContent, deleteContentLoading, deleteContentError,
      openEditModal,
      createContent,
      openGeneratePage, currentPage, totalPages, availableStatuses,
      selectedStatuses, pageSize, publishAllowed, streamData, archiveContent, copyContent,
      showWpSyncWarning, canSyncWordpressTaxonomies, syncWordpressTaxonomies, syncTaxonomiesLoading,
      syncTaxonomiesMessage, syncTaxonomiesError, isWordpressStream
    }
  },
}
</script>

<style>
.streams-content-page {
  background:
    radial-gradient(circle at 2% 3%, rgba(66, 153, 225, 0.2), transparent 36%),
    radial-gradient(circle at 98% 2%, rgba(56, 189, 248, 0.18), transparent 32%),
    #f3f7ff;
  min-height: 100%;
  padding: 10px 14px 12px;
}

.streams-content-hero {
  border-radius: 16px;
  background: linear-gradient(135deg, #10305f 0%, #1b4f93 60%, #1e67b7 100%);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 18px 40px rgba(16, 48, 95, 0.22);
  padding: 10px 12px;
  margin-bottom: 12px;
}

.hero-top-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
}

.hero-stream-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex-wrap: wrap;
}

.stream-type-pill,
.stream-name-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 12px;
  line-height: 1.2;
}

.stream-type-pill {
  border: 1px solid rgba(255, 255, 255, 0.42);
  background: rgba(255, 255, 255, 0.1);
  color: #f8fbff;
  font-weight: 700;
}

.stream-type-chat {
  color: #dbeafe;
  font-weight: 500;
}

.stream-name-pill {
  border: 1px solid rgba(255, 255, 255, 0.24);
  background: rgba(255, 255, 255, 0.15);
  color: #eef5ff;
  font-weight: 600;
  max-width: 380px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.hero-actions {
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
  align-items: center;
  margin-left: auto;
}

.hero-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  height: 30px;
  min-height: 30px;
  border-radius: 8px;
  padding: 0 10px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 1;
  white-space: nowrap;
  text-align: center;
}

.hero-btn .bi {
  font-size: 12px;
  line-height: 1;
  margin-right: 0 !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.hero-btn .spinner-border {
  width: 12px;
  height: 12px;
  border-width: 2px;
  margin-right: 0 !important;
}

.hero-btn.hero-btn--primary {
  background: #ffffff;
  border-color: #cfe2ff;
  color: #103f77;
  box-shadow: 0 8px 18px rgba(12, 31, 65, 0.22);
}

.hero-btn.hero-btn--primary:hover {
  background: #f4f8ff;
  border-color: #deebff;
  color: #0d3564;
}

.hero-btn.hero-btn--ghost {
  border-color: #cfe2ff;
  color: #103f77;
  background: #ffffff;
}

.hero-btn.hero-btn--ghost:hover {
  border-color: #deebff;
  color: #0d3564;
  background: #f4f8ff;
}

.hero-bottom-row {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed rgba(219, 234, 254, 0.34);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;
}

.status-filter-btn {
  border-radius: 6px;
  border-color: #cfdcf5;
  color: #3a4b6a;
  background: #fff;
  font-weight: 600;
}

.status-filter-btn:hover {
  background: #f3f7ff;
  border-color: #bcd0f2;
  color: #26344f;
}

.status-filter-btn--inline {
  padding: 0.12rem 0.35rem;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
}

.status-counter {
  margin-left: 6px;
  border-radius: 999px;
  min-width: 16px;
  padding: 0 4px;
  text-align: center;
  font-size: 10px;
  background: #e9f1ff;
  color: #2d4f87;
  border: 1px solid #d2e1fd;
}

.status-filter-menu {
  border-radius: 12px;
  border: 1px solid #d7e3f8;
  box-shadow: 0 16px 28px rgba(15, 23, 42, 0.12);
  min-width: 210px;
}

.status-check-item {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 6px;
  font-size: 13px;
  color: #31456a;
}

.status-check-item:last-child {
  margin-bottom: 0;
}

.status-check-item .form-check-input {
  margin-top: 0;
}

.hero-pagination-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.page-size-indicator,
.page-size-indicator.text-muted {
  font-size: 12px;
  color: #ffffff !important;
}

.hero-pagination .pagination {
  margin-bottom: 0;
}

.streams-content-table-card {
  border: 1px solid #dee8f8;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.06);
  overflow: hidden;
}

.streams-content-warning {
  border: 1px solid #f4bf86;
  border-radius: 10px;
  background: #fff1df;
  color: #8f4f12;
  font-size: 13px;
  font-weight: 600;
  padding: 8px 10px;
}

.sync-taxonomies-btn {
  font-weight: 700;
}

.hero-btn.hero-btn--sync {
  padding-left: 10px;
  padding-right: 10px;
  border-color: #89b4e9;
  background: #2b6cb0;
  color: #ffffff;
  box-shadow: 0 8px 18px rgba(12, 31, 65, 0.22);
}

.hero-btn.hero-btn--sync:hover:not(:disabled) {
  border-color: #79a8e2;
  background: #245e9d;
  color: #ffffff;
}

.hero-btn.hero-btn--sync:disabled {
  opacity: 0.72;
  border-color: #86a8d1;
  background: #4f78aa;
  color: #ffffff;
  cursor: not-allowed;
  box-shadow: none;
}

.streams-content-loading {
  text-align: center;
  color: #57709b;
  font-weight: 600;
  padding: 30px 12px;
}

.streams-content-empty {
  margin: 12px;
}

.pagination .page-item:not(.disabled) {
  cursor: pointer;
}

.pagination .page-item.disabled {
  cursor: default;
}

.delete-content-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1200;
}

.delete-content-modal {
  background: #fff;
  border-radius: 14px;
  width: 92vw;
  max-width: 460px;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.28);
  overflow: hidden;
  border: 1px solid #e5eaf6;
}

.delete-content-head {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 14px 10px;
  border-bottom: 1px solid #edf1f8;
}

.delete-content-icon {
  width: 34px;
  height: 34px;
  border-radius: 999px;
  background: #fff3f3;
  color: #dc3545;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  flex: 0 0 34px;
}

.delete-content-title-wrap {
  min-width: 0;
}

.delete-content-title {
  color: #1f2d45;
  font-weight: 700;
}

.delete-content-subtitle {
  color: #6b7a93;
  font-size: 12px;
  margin-top: 2px;
}

.delete-content-close {
  margin-left: auto;
  border: none;
  background: transparent;
  color: #7a879c;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.delete-content-close:hover {
  background: #f3f6fb;
  color: #2f3c54;
}

.delete-content-body {
  padding: 12px 14px;
}

.delete-content-item {
  border: 1px dashed #d8e1f2;
  border-radius: 10px;
  background: #f9fbff;
  padding: 8px 10px;
  font-size: 13px;
  color: #2a3752;
  display: flex;
  align-items: center;
  gap: 6px;
}

.delete-content-footer {
  padding: 10px 14px 14px;
  border-top: 1px solid #edf1f8;
  display: flex;
  justify-content: flex-end;
}

@media (max-width: 992px) {
  .streams-content-page {
    padding: 8px 10px 10px;
  }

  .streams-content-hero {
    padding: 10px;
  }

  .hero-actions {
    width: 100%;
    margin-left: 0;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .hero-actions .hero-btn {
    width: 100%;
  }

  .hero-bottom-row {
    align-items: stretch;
  }

  .hero-pagination-wrap {
    width: 100%;
    justify-content: space-between;
  }
}

@media (max-width: 768px) {
  .stream-name-pill {
    max-width: 100%;
  }

  .hero-actions {
    grid-template-columns: 1fr;
  }

  .hero-pagination-wrap {
    flex-direction: column;
    align-items: flex-start;
  }

  .hero-pagination .pagination {
    flex-wrap: wrap;
    row-gap: 4px;
  }
}
</style>

